import postAPI from './postAPI.js'

export default async function postUpdateAction(actionData) {
    const data = await postAPI('admin/taskflows/actions/update', actionData);
    return data;
}
